import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const CircleExclamationIcon = _ref => {
  let {
      size = "13",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1602 15.3044C14.7446 16.7206 12.8609 17.5 10.8559 17.5C8.85086 17.5 6.96649 16.7206 5.55086 15.3044C4.12086 13.8744 3.33398 11.9906 3.33398 10C3.33398 8.00812 4.12086 6.12437 5.55086 4.695C6.96649 3.27938 8.85086 2.5 10.8559 2.5C12.8609 2.5 14.7446 3.27938 16.1602 4.695C17.5615 6.09625 18.3334 7.97937 18.3334 10C18.3334 12.0194 17.5615 13.9031 16.1602 15.3044ZM17.044 3.81125C15.3921 2.15938 13.1946 1.25 10.8559 1.25C8.51711 1.25 6.31898 2.15938 4.66711 3.81125C3.00086 5.47625 2.08398 7.67438 2.08398 10C2.08398 12.3244 3.00086 14.5225 4.66711 16.1881C6.31898 17.8406 8.51711 18.75 10.8559 18.75C13.1946 18.75 15.3921 17.8406 17.044 16.1881C18.6815 14.5513 19.5834 12.3531 19.5834 10C19.5834 7.64563 18.6815 5.4475 17.044 3.81125Z",
    fill: color
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5067 11.875H11.1599C11.3267 11.875 11.4642 11.7437 11.4717 11.5762L11.7561 5.32625C11.7642 5.14875 11.6217 5 11.4436 5H10.223C10.0449 5 9.90236 5.14875 9.91049 5.32625L10.1949 11.5762C10.2024 11.7437 10.3399 11.875 10.5067 11.875Z",
    fill: color
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.834 13.125C10.3165 13.125 9.89648 13.545 9.89648 14.0625C9.89648 14.58 10.3165 15 10.834 15C11.3521 15 11.7715 14.58 11.7715 14.0625C11.7715 13.545 11.3521 13.125 10.834 13.125Z",
    fill: color
  }), " ");
};
export default CircleExclamationIcon;